import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const StreetNumber = () => {
  const { t, updateAddress, errors, streetNumber, streetName, city } = useAddress()

  return (
    <SDFormControl plainLabel error={getError('streetNumber', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.street_number')}
        onBlur={streetNumber =>
          updateAddress({ streetNumber, label: (streetNumber ?? '') + ' ' + (streetName ?? '') + ' ' + (city ?? '') })
        }
        currentValue={streetNumber}
      />
    </SDFormControl>
  )
}

export default StreetNumber
